// @flow

import React, { Component } from 'react';
import I18n from '../../../i18n/I18n';
import styles from './StarsIconRating.scss';

type Props = {
    scoreMax: number,
    score: number | string,
    count: number,
    showRating: boolean,
    showCount: boolean,
    size: number,
}

class StarsIconRating extends Component<Props> {
  render() {
    const DEFAULT_MAX_SCORE = this.props.maxScore || 10;
    const DISPLAY_MAX_SCORE = 5;
    const scoreMax = this.props.scoreMax || DISPLAY_MAX_SCORE;
    const score = this.props.score / (DEFAULT_MAX_SCORE / DISPLAY_MAX_SCORE) || 0;
    const percentageValue = `${score / scoreMax * 100}%`;
    const size = this.props.size + 'px' || '12px';
    const count = this.props.count || 0;

    return (
      <div className={styles.container} style={{ fontSize: size }}>
        <span className={this.props.showRating ? styles.value : styles.hideValue} itemProp="ratingValue">
          {score}
        </span>
        <span className={styles.stars}>
          <span className={styles.valueIcons} style={{ width: percentageValue }} />
        </span>
        {this.props.showCount &&
          count > 0 &&
          <div className={styles.count}>
            {count}&nbsp;{I18n.getText('ratings.ratings', {}, 'Ratings')}
          </div>}
      </div>
    );
  }
}

export default StarsIconRating;



// WEBPACK FOOTER //
// ./src/components/common/starRating/StarsIconRating.js